<template>
  <aside
    class="vue-sidebar-wrapper"
    role="complementary"
    aria-label="Sidebar"
    :aria-hidden="!visible"
    :class="{ 'is-visible': visible }"
  >
    <button
      v-if="hasPullBtn"
      type="button"
      class="vue-sidebar-pull-btn"
      @click="toggle"
    >
      <i class="hi hi-left" />
    </button>
    <transition
      @after-enter="onOpened"
      @after-leave="onClosed"
    >
      <div
        v-show="visible"
        class="vue-sidebar"
        :style="sidebarStyle"
      >
        <div
          :id="id"
          class="vue-sidebar-content"
        >
          <template v-if="backButton">
            <div class="is-block">
              <a
                href="#"
                class="btn-back"
                @click.prevent="hide"
              >
                <i class="hi hi-left hi-12" />
                {{ backButtonLabel }}
              </a>
              <button
                type="button"
                role="button"
                title="Close sidebar"
                aria-hidden="true"
                class="btn btn-icon close pull-right"
                @click="close"
              >
                <i class="hi hi-close hi-9" />
              </button>
            </div>
          </template>
          <template v-else-if="hasCloseButton">
            <button
              type="button"
              aria-hidden="true"
              role="button"
              title="Close sidebar"
              class="btn btn-icon close ml-auto"
              @click="close"
            >
              <i class="hi hi-close hi-9" />
            </button>
          </template>
          <h4 v-if="title">
            {{ title }}
          </h4>
          <slot />
        </div>
      </div>
    </transition>
  </aside>
</template>

<script>
import { SIDEBAR_OPEN_WIN_EVENT } from '~/app_constants';

const EXCLUDE_SELECTOR =
  '.modal, .modal-backdrop, .app-lazy-select, .lazy-select-content, .select2-container:not([data-select2-ignore]), .select2-selection__choice__remove, .app-sidebar-exclude, table.table-condensed';

export default {
  name: 'AppSidebar',
  props: {
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    dismissOnBodyClick: {
      type: Boolean,
      default: true,
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
    hasPullBtn: {
      type: Boolean,
      default: false,
    },
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
    sidebarStyle: {
      type: String,
      default: '',
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        window.dispatchEvent(new CustomEvent(SIDEBAR_OPEN_WIN_EVENT));
      }
    },
  },
  created() {
    this.onClick = this.onClick.bind(this);
  },
  mounted() {
    window.document.addEventListener('click', this.onClick);
  },
  beforeDestroy() {
    window.document.removeEventListener('click', this.onClick);
  },
  methods: {
    toggle() {
      this.visible ? this.$emit('close') : this.$emit('show');
    },
    hide() {
      this.$emit('hide');
    },
    close() {
      this.$emit('close');
    },
    onClick(e) {
      if (
        this.visible &&
        this.dismissOnBodyClick &&
        !this.$el.contains(e.target) &&
        !e.target.closest(EXCLUDE_SELECTOR)
      ) {
        this.close();
      }
    },
    onOpened() {
      this.$emit('opened');
    },
    onClosed() {
      this.$emit('closed');
    },
  },
};
</script>
